import React, { useState } from "react";
import {
  Box,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import { useSnackbar } from "notistack";
import axios from "axios";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";
import { useHistory, Link } from "react-router-dom";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    try {
      if (validateInput(username, password)) {
        const url = config.endpoint;
        const response = await axios.post(`${url}/auth/login`, {
          username: username,
          password: password,
        });
        if (response.data.success) {
          enqueueSnackbar("Logged in successfully", { variant: 'success' });
          const { token, username, balance } = response.data;
          persistLogin(token, username, balance - 0);
        }
      }
    } catch (error) {
      handleLoginError(error);
    }
  };

  const handleLoginError = (error) => {
    if (error.response) {
      enqueueSnackbar(error.response.data.message, { variant: 'error' });
    } else if (error.request) {
      enqueueSnackbar("No response received from the server", { variant: 'error' });
    } else {
      enqueueSnackbar("Something went wrong. Check that the backend is running, reachable, and returns valid JSON.", { variant: 'error' });
    }
  };

  const validateInput = (username, password) => {
    if (username === "") {
      enqueueSnackbar("Username is a required field", { variant: 'warning' });
      return false;
    }
    if (password === "" || password.length < 6) {
      enqueueSnackbar("Password is a required field", { variant: 'warning' });
      return false;
    }
    return true;
  };

  const persistLogin = (token, username, balance) => {
    localStorage.setItem("token", token);
    localStorage.setItem('username', username);
    localStorage.setItem('balance', balance);
    history.push("/");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="Username"
            name="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            type="text"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            fullWidth
          />
          <Button
            className="button"
            variant="contained"
            onClick={login}
          >
            LOGIN TO QKART
          </Button>
          <p className="secondary-action">
            Don’t have an account?{" "}
            <Link to="/register" className="link">Register now</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
